import { AbstractControl } from '@angular/forms';

export const hasRequiredField = (abstractControl: AbstractControl): boolean => {
    if (abstractControl && abstractControl.validator) {
        const validator = abstractControl.validator({}as AbstractControl);
        if (validator && validator.required) {
        return true;
        }
    }
    return false;
};

export const roundToDecimal = (nb: number, decimal: number): string => {
    const power = Math.pow(10, decimal);
    return (Math.round(nb * power) / power).toFixed(decimal);
};

